<button
  class="btn btn-close-modal"
  type="button"
  [attr.aria-label]="'textToSpeech.close' | transloco"
  (click)="closeModal()"
>
  <img
    src="assets/images/misc/close.svg"
    alt="{{ 'common.close' | transloco }}"
  />
</button>
<div class="container">
  <div class="row headline-row">
    <p>{{ 'form.requestQuoteModal.title' | transloco }}</p>
  </div>
  <div class="row text-row">
    <span>
      {{ 'form.requestQuoteModal.subTitle' | transloco }}
    </span>
  </div>
  <div class="row contact-row">
    @if (phoneNumber) {
      <div>
        <span class="icon-container">
          <fa-icon [icon]="faPhone"></fa-icon>
        </span>
        <a class="h4" [href]="'tel:' + phoneNumber | phoneFilter">
          {{ phoneNumber }}
          <span class="phone-rate">
            {{ phoneRate }}
          </span>
        </a>
      </div>
    }
    @if (email) {
      <div>
        <span class="icon-container">
          <fa-icon [icon]="faEnvelope"></fa-icon>
        </span>
        <a class="h4" [href]="'mailTo:' + email">
          {{ email }}
        </a>
      </div>
    }
  </div>
  <div class="row button-row">
    <button class="btn btn-primary" (click)="closeModal()">
      {{ 'form.requestQuoteModal.buttonLabel' | transloco }}
    </button>
  </div>
</div>
